import {FormikErrors} from 'formik';
import {isNumber, set} from 'lodash-es';
import {riskNotesFormType} from './riskNotesFields';
import {riskSegmentsOrderedByBusinessLogic} from './RiskNotesFormHelpers';
import {GetRiskNotes_reviewDetails_contacts} from '../../schema-types/GetRiskNotes';

export const validateRiskNotes = (
  contacts: GetRiskNotes_reviewDetails_contacts[],
  values: riskNotesFormType,
  errors: FormikErrors<riskNotesFormType>
): FormikErrors<riskNotesFormType> => {
  riskSegmentsOrderedByBusinessLogic.forEach((riskType) => {
    if (!values[riskType].noChange) {
      if (!values[riskType].notes.length) {
        set(errors, `${riskType}.notes`, 'Required');
      }
    }
    contacts.forEach((contact) => {
      if (typeof values.giaHasLiquidityNeeds[contact.id] !== 'boolean') {
        set(errors, `giaHasLiquidityNeeds.${contact.id}`, 'Required');
      }
      if (typeof values.pensionHasLiquidityNeeds[contact.id] !== 'boolean') {
        set(errors, `pensionHasLiquidityNeeds.${contact.id}`, 'Required');
      }
    });
  });

  const allSectionsNoChange = riskSegmentsOrderedByBusinessLogic
    .map((riskType) => values[riskType].noChange)
    .every((val) => val);
  const requiresJustification = values.hasNoRiskDicussion || allSectionsNoChange;
  if (requiresJustification) {
    if (!values.noChangeReasonNotes.length) {
      set(errors, `noChangeReasonNotes`, 'Required');
    }
    if (allSectionsNoChange && !values.hasNoRiskDicussion) {
      set(
        errors,
        `hasNoRiskDicussion`,
        'Please tick "No risk discussion" since all sections are marked no change'
      );
    }
  } else {
    for (const contact of contacts) {
      if (!isNumber(values.outcomeRisk[contact.id]?.score)) {
        set(errors, `outcomeRisk.${contact.id}.score`, 'Required');
      }
      if (!values.outcomeRisk[contact.id]?.notes?.length) {
        set(errors, `outcomeRisk.${contact.id}.notes`, 'Required');
      }
    }
  }
  return errors;
};
